import Vue from 'vue'
import store from '../../store/store';
import Router from 'vue-router'
import setLoginParameters from '../Unit/set-login-and-logout-parameters'
import axios from "../plugins/axios";
import {mapMutations} from "vuex";

Vue.use(Router)
Vue.prototype.$session = null;
const router = new Router({
  linkActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      meta:
        {
          page: 'index',
          public: true
        },
      component: resolve => require(['@/components/home/offline'], resolve)
    },
    {
      path: '/withdraw',
      name: 'withdraw',
      meta:
        {
          page: 'withdraw',
          public: false
        },
      component: resolve => require(['@/components/home/withdraw'], resolve)
    },
    {
      path: '/withdraw/:type',
      name: 'withdraw',
      meta:
        {
          page: 'withdraw_item',
          public: false
        },
      component: resolve => require(['@/components/home/methods'], resolve)
    },
    {
      path: '/deposit',
      name: 'deposit',
      meta:
        {
          page: 'deposit',
          public: false
        },
      component: resolve => require(['@/components/home/deposit'], resolve)
    },
    {
      path: '/deposit/:type',
      name: 'deposit',
      meta:
        {
          page: 'deposit_item',
          public: false
        },
      component: resolve => require(['@/components/home/methods'], resolve)
    },
    {
      path: '*',
      name: 'all',
      redirect: '/'
    }
  ]
});
 
router.beforeResolve((to, from, next) => {
  if (to.query.bearer) {
    console.log('New Bearer', to.query.bearer );
    process.$session = null;

    validateToken(to, from, next, process);
  }else {
    if(process.$session){
      console.log('Used Existing Session ', process.$session );
      next();
    }else{
      if(to.name == 'index'){
        next();
      }else{
        router.push('/');  
      }
      
    }
  }
});

/**
 *
 * @param to
 * @param from
 * @param next
 * @returns {Promise<void>}
 */
async function  validateToken(to, from, next, oVue){
 
  await get_token(to.query.bearer)
    .then(response => {
      let token = response.data.token;
      setLoginParameters.setToken(token);

      let tempObj = {};
      tempObj.email = response.data.user_email;
      tempObj.id = response.data.user_id;
      tempObj.account = response.data.user_account;
      tempObj.allow_p2p = response.data.allow_p2p;
      tempObj.balance = response.data.balance;
      tempObj.token = response.data.token;
      let jsonStr = JSON.stringify(tempObj);
      if(localStorage.persistent !== undefined){
        if(JSON.parse(localStorage.persistent).id !== undefined 
            && JSON.parse(localStorage.persistent).id != response.data.user_id){
              localStorage.removeItem('trc20addr');
              localStorage.removeItem('trc20addrValid');
              localStorage.removeItem('erc20addr');
              localStorage.removeItem('erc20addrValid');
        }
      }
      localStorage.setItem('persistent', jsonStr);

       oVue.$session = tempObj;

       console.log('Created New Session ', oVue , process.$session);

       store.commit('changePreloaderVisible', false)

      if(to.query.route){
        router.push('/'+to.query.route)
      }else{
        router.push('/')
      }
      
    })
    .catch(error => {
      console.log(error)
    })
}


/**
 * @param token
 * @returns {*}
 */
function get_token(token) {
  return axios.post(`rlogin`, {bearer: token})
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js